import push from '../../utils/routing';
import { getAssignmentsPath } from './routes';

export const goToAssignments =
  (
    spaceId: string,
    sectionId?: string | null,
    queryParams?: Record<string, string>
  ) =>
  () =>
    push({
      pathname: getAssignmentsPath(spaceId),
      ...(queryParams ? { query: queryParams } : {}),
    });
